import { defineStore } from 'pinia'
import { api } from 'boot/api-access';
import { navigateTo } from 'src/utils/navigation.js'

export const useAuthStore = defineStore('auth', {
  state: () => ({
    user: null,
    token: localStorage.getItem('token') || null,
    returnUrl: '/'
  }),

  actions: {
    async login(username, password, handleReturnUrl = true) {
      return api
        .post(`/auth/login`, { login: username, password: password })
        .then(({ result }) => {
            if(!result) {
              return false;
            }

            this.user = result
            this.token = result.token
            // store user details and jwt in local storage to keep user logged in between page refreshes
            localStorage.setItem('token', this.token)

            if (handleReturnUrl) {
              // Перенаправляем на предыдущий URL или на главную
              navigateTo(this.returnUrl || '/')
            }
            return true
        });
    },

    async register(data, handleReturnUrl = true) {
      return api
        .post(`/auth/Register`, data)
        .then(({ result }) => {
          this.user = result
          this.token = result.token
          // store user details and jwt in local storage to keep user logged in between page refreshes
          localStorage.setItem('token', this.token)

          if (handleReturnUrl) {
            // Перенаправляем на предыдущий URL или на главную
            navigateTo(this.returnUrl || '/')
          }
        })
    },

    logout() {
      this.user = null
      this.token = null
      localStorage.removeItem('token')

      navigateTo('/login')
    },

    async checkAuth() {
      if (!this.token) return false

      try {
        const { result } = await api.get('/auth/me')
        return result;
      } catch {
        this.token = null;
        return false
      }
    }
  },

  getters: {
    isAuthenticated: (state) => !!state.token
  }
})
